import React from 'react';
import styled from 'styled-components';
import Chip from '@mui/material/Chip';

export default function Beneficiaries({ data }) {
  if (!data) {
    return null;
  }

  const { demographics = [], beneficiary_description } = data;

  return (
    <Container>
      <Table>
        <Heading>
          <h2>Beneficiaries</h2>
          <p>Below is the grantee's description of the people served by this program and selected demographic and geographic categories
          representing these beneficiaries.</p>
          {demographics
            .map(label => (
              <StyledChip key={label} {...{ label }}/>
            ))}
          <br/><br/>
          {beneficiary_description} 
        </Heading>
      </Table>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const StyledChip = styled(Chip)`
  margin-left: 10px;
`;
const Table = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;
  background-color: #FFFFFF;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
  padding-bottom: 20px; 
`;

const Heading = styled.div`
  padding: 20px;
  padding-bottom: 0px;
  h2 {
    color: #595959;
    font-size: 24px;
    font-weight: 700;
  }
  p {
    color: #595959;
    font-size: 14px;
    font-weight: 400;
  }
`;

const TableRow = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #f5f8fa;
  border-top: solid 1px #ccd7e3;
  border-bottom: solid 1px #ccd7e3;
  display: flex;
  flex-direction: row;
  div:nth-child(1) {
    flex: 1;
  }
  div:nth-child(2) {
    flex: 1;
  }
`;

const P = styled.div``;

const Sub = styled.span`
  font-size: 0.8em;
  font-weight: bold;
`;